export default {"productCard":"tVmjK","image--leading":"NmqRR","image--trailing":"_3xPxd","imageContainer":"TrcBL","textContainer":"hmFtk","title":"E-Oti"};